import { createStoreProvider, ReduxStore } from '@st/redux'
import {
  DocumentViewerInit,
  DocumentViewerMessage,
  DocumentViewerState,
  documentViewerModule
} from './document-viewer-module'
import { ReactNode, useState } from 'react'

const { StoreProvider, useProcessState, useProcess, useProcessMessages } = createStoreProvider()

export function useDocumentViewerState<T>(selector: (state: DocumentViewerState) => T) {
  const state = useProcessState(documentViewerModule, selector)
  return state
}

export function useInitDocumentViewer(documentViewerInit: DocumentViewerInit) {
  useProcess(documentViewerModule, documentViewerInit)
}

export function useDocumentViewer() {
  const process = useProcess(documentViewerModule)
  return process
}

export function useDocumentViewerMessages(handler: (msg: DocumentViewerMessage) => void) {
  const messages = useProcessMessages(documentViewerModule, handler)
  return messages
}

export function DocumentViewerProvider({ children }: { children: ReactNode }) {
  const [store] = useState(() => new ReduxStore({ name: 'docviewer' }))
  return <StoreProvider store={store}>{children}</StoreProvider>
}
